import { metrics } from '@mntn/observability'
import type { GraphQLFormattedError } from 'graphql'

const meter = metrics.getMeter('gary-client')

const fieldErrorCounter = meter.createCounter('gary.graphql.field_errors_total', {
  description: 'GraphQL errors returned by Gary, by operation and field path',
  unit: '{error}',
})

/**
 * Numeric path segments are dropped: `rows.0.spend` and `rows.417.spend` are the same
 * failure, and keeping the index would give the metric one series per row.
 */
export const toErrorPath = (path: GraphQLFormattedError['path']) => {
  const named = path?.filter(segment => typeof segment === 'string') ?? []
  return named.length > 0 ? named.join('.') : 'root'
}

/** `extensions` is server-supplied, so the code is narrowed rather than trusted. */
export const toErrorCode = (extensions: GraphQLFormattedError['extensions']) => {
  const code = extensions?.code
  if (typeof code === 'string') return code
  if (typeof code === 'number') return String(code)
  return 'unknown'
}

export const recordGaryFieldError = ({
  operationName,
  path,
  code,
}: {
  operationName: string
  path: string
  code: string
}) => {
  fieldErrorCounter.add(1, {
    operation_name: operationName,
    error_path: path,
    error_code: code,
  })
}
